import { EventManager } from 'micro-event-manager';

const eventManager = new EventManager();

export default eventManager;
